import markdownit from 'markdown-it'
import  * as AppliedValues from "@/components/explorer/visualizations/AppliedValues.js";
import {ChartTypeEnum, getchartNameFromApiName} from  "@/components/explorer/visualizations/ChartTypeEnum.js"
import * as Accessibility from "@/components/accessibility/accessibility.js";
import { event } from 'vue-gtag'
import _Highcharts from "highcharts";

const version = __APP_VERSION__

const md = markdownit()

class ChartSettings {
    constructor(xAxisDim, seriesDim, type) {
		this.type = type
        this.xAxisDim = xAxisDim;
        this.seriesDim = seriesDim;
    }
}

async function defineChartProps(type, indicatorObj, chartSettings, { onMoreClick }) {
	let yValue = indicatorObj.valuesLabel;
	let allFilters = getCategoryFilters(indicatorObj)

	chartSettings.request =  AppliedValues.buildRequest(indicatorObj, chartSettings, yValue, allFilters);
	//AppliedValues.applyRequestFilters(indicatorObj, type, chartSettings.request)
	chartSettings.request.categories.forEach(cat => {
		if(cat.filters.length == 0) {
			throw new Error("No records found");
		}
	})
	if(import.meta.env.VITE_APP_DEBUG)
		console.log('chartSettings', chartSettings)


	let results = await fetchData(chartSettings.request)
	if(Object.keys(results).length == 0 || Object.keys(Object.values(results)[0]).length == 0) {
	 	throw new Error("No records found");
	}
	if(import.meta.env.VITE_APP_DEBUG)
		console.log('response Line chart',results)

	let props = buildChartJson(type, indicatorObj, yValue, chartSettings, results, { onMoreClick })
	if(import.meta.env.VITE_APP_DEBUG)
		console.log('chartProps',props)
	return props;
}

async function fetchData(request) {
	//console.log(indicatorName)
	const apiUrl = import.meta.env.VITE_API_URL;

	let reqDims = request.xAxis + ',';
	let reqFilters = '';
	request.categories.forEach((cat) => {
		if(cat.selected) {
			reqDims += cat.categoryName;
		}
		reqFilters += cat.categoryName + ': ' + cat.filters.join() + '|';
	})
	event('filter_dataset', { 'indicator' : request.datasetName, 'dimensions': reqDims, 'filter' : reqFilters.slice(0,100).slice(0,-1) })

	let url = apiUrl + '/indicators/api/chartdata'
	let response = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'x-api-version': version
		},
			body: JSON.stringify(request)
		}
	)
	if (!response.ok) {
		throw new Error(`HTTP status: ${response.status}`);
	}
	return await response.json()
}

const buildChartJson = (type, indicatorObj, yValue, chartSettings, result, { onMoreClick }) => {

	const valuesUnit = indicatorObj.valuesUnit	
	//const usdFormatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2});
	const pctFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: indicatorObj.decimalPrecision, maximumFractionDigits: 2});
	const floatFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: indicatorObj.decimalPrecision, maximumFractionDigits: 100});
	const numFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 100});
	//TODO: Enable new formatter logic if Float valuesUnit implemented
	let formatter = valuesUnit == "Currency"?numFormatter:valuesUnit == "Percent"?pctFormatter:valuesUnit=="Float"?floatFormatter:numFormatter
	//let formatter = valuesUnit == "Currency"?numFormatter:valuesUnit == "Percent"?pctFormatter:numFormatter
	//const valuesMultiplier = (indicatorObj.chartMultiplier ? parseInt(indicatorObj.chartMultiplier) : 1);
	//const valuesRoundingUnit = (indicatorObj.roundingUnit && indicatorObj.roundingUnit.length > 0 ? '(' + indicatorObj.roundingUnit.replace(/[$%]/g, "") + ')' : null);
	const valuesRoundingUnit = (indicatorObj.roundingUnit && indicatorObj.roundingUnit.length > 0 ? '(' + indicatorObj.roundingUnit + ')' : null);
	const axisLabel = indicatorObj.roundingUnit

	const classNameBase = Accessibility.readUserPreference('patternfill') === 'true' ? 'indicators-chart-series-dashed-' : 'indicators-chart-series-';
	const modulo = Accessibility.readUserPreference('colorblind') === 'achromatopsia' ? 10 : 88;

	let ctype = type != null?type:'column'
  	let chartprops = {
		chart: {
			type: ctype,
			styledMode: true,
			//height: 560,
			height: 0,
			width: null,
			events: {
				render() {
					//add Full Source button link to footer to support mobile format
					const links = this.container.querySelectorAll('.footnote-more');
					if(links != null) {
						links.forEach(link => {
							if (link && !link.dataset.bound) {
								link.dataset.bound = 'true';

								link.addEventListener('click', (e) => {
									e.preventDefault();
									//console.log('clicked', e)
									onMoreClick(e)
								});
							}
						})
					}

					//reformat title/subtitle to support wrapped labels in mobile layout
					const chart = this;
					if (!chart.title || !chart.subtitle) {
						return;
					}
					const titleBBox = chart.title.getBBox();
					if(titleBBox.height < 30) {
						chart.subtitle.attr({
							y: chart.title.alignAttr.y + titleBBox.height 
						});
					} else {
						chart.title.attr({
							y: titleBBox.height - 50
						});						
						chart.subtitle.attr({
							y: titleBBox.height
						});
					}
					
					const caption = this.caption;
					if (caption && caption.css) {
						caption.css({
							width: (this.chartWidth - 40) + 'px'
						});
					}
				}
			}
		},
		credits: {
    		enabled: false,
		},
    	title: {
			text: ''
		},
    	subtitle: {
			text: ''
		},		
		legend: {
			align: "left",
			events: {
				itemClick: function (e) {
					e.preventDefault(); 
					return false;					
				}
			},
			maxHeight: 150,
			title: {
				text: ''
			}
		},
		xAxis: {
			type: 'linear',
			tickInterval: 1,
			title: { text: 'Year' }
		},
		yAxis: {
			title: {
				text: axisLabel
			},
			labels: {			
				formatter: function () {
					if(this.value == 0) {
						return this.value
					} else {
						return formatter.format(this.value) //_Highcharts.numberFormat(this.value, 0)
					}
				}
			}
		},	
		series: [],
		responsive: {
			rules: [{
				condition: {
					maxWidth: 600
				},
				chartOptions: {
					legend: {
						enabled: false
					}
				}
			}]
		},		
		exporting: {
			enabled: true, // still needed for export functionality
			libURL: './highcharts-libs/',
			local: true,
			fallbackToExportServer: false, // use offline export only
			chartOptions: {
				chart: {
					type: ctype,
					style: {
						//prevents warning on fetching font files that are not needed
						fontFamily: 'Roboto,sans-serif'
					},
					spacingBottom: 24
				},
				title: {
					style: {
						fontSize: '20px', //'var(--font-size-H6, 1.25rem)',
						color: '#2C2C2C' //'var(--text-Header)'
					}
				},
				legend: {
					itemStyle: {
            			fontFamily: 'Roboto,sans-serif',
						fontSize: '12px', //'var(--font-size-Base, 1rem);',
						color: '#2C2C2C'  //'var(--text-Primary, #2C2C2C);',
					},
					title: {
						style: {
              				fontFamily: 'Roboto,sans-serif',
							fontSize: '16px', //' var(--font-size-Base, 1rem);',
							color: '#2C2C2C'   //'var(--text-Primary, #2C2C2C);',
						}
					}
				},
				xAxis: {
					labels: {
						style: {
            				fontFamily: 'Roboto,sans-serif',
							fontSize: '12px' // Override x-axis label font size for export
						},
						useHTML: false,
						formatter: function() {
							if(typeof this.value === 'string') {
								return this.value.replace(';', '</br/>');
							} else {
								return this.value;
							}
						}						
					},
					title: {
						style: {
              				fontFamily: 'Roboto,sans-serif',
							color: '#171717', // 'var(--text-Header,#171717)',
							fontSize: '16px', //'var(--font-size-Base, 1rem)',
						}
					}
				},
				yAxis: {
					title: {
						style: {
							color: '#171717', // 'var(--text-Header,#171717)',
							fontFamily:  'Roboto, sans-serif', //'var(--font-family-Title, Roboto)',
							fontSize: '16px', //'var(--font-size-Base, 1rem)',
							fontStyle: 'normal',
							fontWeight: '500'
						}
					},
					labels: {
						itemStyle: {
             				fontFamily: 'Roboto, sans-serif', //'var(--font-family-Title, Roboto)',
							fontSize: '16px' // 'var(--font-size-Base, 16px);' // Set the font size here
						}
					}
				}
			},
			buttons: {
			 	contextButton: {
			 		enabled: false // hides the built-in button
			 	}
			},
 			error: function(options, err) {
				// This function will be called if an export error occurs
				console.log('Highcharts Export Error:', err);
				console.log('Exporting options:', options);
				//alert('Export failed! Please try again or contact support.');
			},
		},
  		tooltip: {
			shared: true, // <--- Key setting
			useHTML: true,			
			formatter: function () {
				
				let title = yValue;
				if(valuesRoundingUnit) {
					title += ' ' + valuesRoundingUnit;
				}
				let header =`<div class="header"><span class="title">${title}</span>`;
				header += 
				`	<div class="label">${chartSettings.xAxisDim.columnName}: ${this.category}</div>
				 	<div class="label">${chartSettings.seriesDim.columnName}:</div>
				 </div>`;

				let i = 0;
				let rows = this.points.map(point => {
					let color;
					const seriesClass = document.querySelector('.'+ classNameBase + i % modulo);
					if(seriesClass) {
						color = getComputedStyle(seriesClass).stroke;
					} else {
						// Fallback if seriesClass not found:
						// Create a temporary element
						const tempElement = document.createElement('div');
						tempElement.className = classNameBase + i % modulo;
						// Hide it and attach it to the DOM so styles compile
						tempElement.style.display = 'none';
						document.body.appendChild(tempElement);
						// Read the property
						color = window.getComputedStyle(tempElement).stroke;
						// Clean up
						document.body.removeChild(tempElement);
					}
					let value = formatter.format(point.y) 
					let icon = createMarker(point, color, 12)
					i++;

					return `<div>${icon}&nbsp;${point.series.name}:&nbsp;<b>${value}</b></div>`;					
				});
				//return '<div class="explorer-tool-tip">' + header + rows.join('') + '</div>';	
				const n = Math.ceil(this.points.length/32); //width: '+n*16+'rem;							
				return '<div class="explorer-tool-tip">' + header + '<ul class="explorer-tool-tip-list" style="columns: ' + n + ' auto;">' + rows.join('') + '</ul></div>';

				function createMarker(point, color, size) {

					//const color = point.color;
					const symbol = point.series.symbol; // point.series.options.marker.symbol;
					switch (symbol) {

						case 'circle':
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<circle cx="6" cy="6" r="4"
										fill="${color}" stroke="${color}" />
								</svg>`;

						case 'square':
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<rect x="2" y="2"
										width="8"
										height="8"
										fill="${color}" stroke="${color}" />
								</svg>`;

						case 'diamond': 
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<path
									d="M6 1 L11 6 L6 11 L1 6 Z"
									fill="${color}" stroke="${color}"  />
								</svg>`;

						case 'triangle':
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<path
										d="M6 1 L11 11 L1 11 Z"
										fill="${color}" stroke="${color}" />
								</svg>`;
						case 'triangle-down':
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<path
										d="M1 1 L11 1 L6 11 Z"
										fill="${color}" stroke="${color}" />
								</svg>`;				
					}
				}

			}
		}
  	}

	let title = `${indicatorObj.valuesLabel} by ${chartSettings.xAxisDim.columnName} and ${chartSettings.seriesDim.columnName}`
	let year = indicatorObj.columns.items.find(x => x.columnName == 'Year')
	if(year) {
		const minYear = Math.min(...year.appliedValues.filter(x => x.selected).map(item => Number(item.name)));
		const maxYear = Math.max(...year.appliedValues.filter(x => x.selected).map(item => Number(item.name)));
		if(minYear == maxYear)
			title += ": " + minYear
		else
			title += ": " + minYear + "\u2013" + maxYear
	}
	chartprops.title.text = title

	let filters = ''
	let cols = 	indicatorObj.columns.items.filter(c => {
		if(c.valueFlag == 0 && c.categoryLabelFlag == 1 && c.columnName != 'Year'
			&& c.columnName != chartSettings.xAxisDim.columnName
			&& c.columnName != chartSettings.seriesDim.columnName
			&& c.columnName != chartSettings.seriesDim.parentColumnName
			&& c.columnName != chartSettings.seriesDim.childColumnName
			&& c.childColumnName == null) {
				return c
			}
		})
	cols.forEach((c, n) => {
		let selected = "<span class='section-break'>" + c.columnName + ": "
		if(c.appliedValues && c.appliedValues.length > 0) {
			let all = c.totalLabel
			let values = c.appliedValues.filter(x => x.selected && x.name != all)
			if(values.length > 0) {
				values.forEach((v, i) => selected += v.name + (i < values.length-1?', ': n < cols.length -1?';':''))
				filters += selected + "</span>"
			}
		}
	})
	chartprops.subtitle.text = filters
	chartprops.xAxis.title.text  = chartSettings.xAxisDim.columnName;
	chartprops.legend.title.text = chartSettings.seriesDim.columnName;
	let availableData = Object.entries(result);

 	//Build series array which contains all data points for a line
	for(let b = 0; b < availableData.length; b++) {
		let xSeriesValue = {}
		let dataPoints = []

		let catValue = availableData[b][0]
		xSeriesValue.name = catValue
		xSeriesValue.visible = true

		let values = availableData[b][1]
 		for (let v in values) {
			let val
			if(typeof values[v] === 'string') {
				let str = values[v].replaceAll(",", "")
				if(str == ''||isNaN(str)) {
					val = null
				} else {
					val = parseFloat(str)
				}
			} else {
				if(isNaN(values[v])) {
					val = null
				} else {
					val = parseFloat(values[v])
				}
			}
			//console.log(values[v], val)
			dataPoints.push([Number(v), val])
		}
		xSeriesValue.data = dataPoints
		xSeriesValue.className = classNameBase + (b % modulo)
		chartprops.series.push(xSeriesValue)
	}
	if(chartSettings.seriesDim.filters) {
		delete chartSettings.seriesDim.filters
	}

	const validateSelected = chartprops.series.find(x => x.visible)
	if(validateSelected == undefined)
		throw new Error("No records found");

	//Build footer
	const abbr = indicatorObj.abbreviations ? indicatorObj.abbreviations.join('; ') + '.' : '';
	const src = md.renderInline(indicatorObj.source);
	//srcHtml is used in the footer mobile modal
	chartSettings.srcHtml = src
	chartSettings.keyHtml = indicatorObj.abbreviations ? indicatorObj.abbreviations.join('.<br />') + '.' : '';

	let footerNotes = `<div class="explorer-footnote-wrapper">`
	if(indicatorObj.abbreviations && indicatorObj.abbreviations.length > 0) {
		footerNotes += `	<span class="explorer-footnote"><span class="title">Key:</span> ${abbr} </span>`
		footerNotes += `	<button class="btn-tertiary footnote-more" data-value='abbreviations'>Full Key</button><br />`
	}
	footerNotes += `	<button class="btn-tertiary explorer-footnote-link" data-value='source'>See full data notes</button><br/>`
	footerNotes += `	<span class="explorer-footnote"><span class="title">Source(s):</span> ${src} </span>`
	footerNotes += `	<button class="btn-tertiary footnote-more" data-value='source'>Full Source</button>`
	footerNotes += `</div>`

	let footerNotesExp = `<div class="explorer-footnote-wrapper">`
	if(indicatorObj.abbreviations && indicatorObj.abbreviations.length > 0) {
		footerNotesExp += `<span class="explorer-footnote"><span class="title">Key:</span> ${abbr} </span><br/>`
	}
	footerNotesExp += `<span class="explorer-footnote"><span class="title">Source(s):</span> ${src} </span></div>`

  	let footer = {}	
	footer.align = "left"
	footer.verticalAlign = "bottom"
	footer.useHTML = true
	footer.text = footerNotes
	chartprops.caption = footer;

	let footerExp = {}
	footerExp.align = "left"
	footerExp.verticalAlign = "bottom"
	footerExp.useHTML = false
	footerExp.text = footerNotesExp
  	chartprops.exporting.chartOptions.caption = footerExp; 

	return chartprops
}

async function refreshLineChart(type, chart,  indicatorObj, chartSettings, filteredDim, { onMoreClick }) {
	if(chart != null) {
		let props = await defineChartProps(type, indicatorObj, chartSettings, { onMoreClick })
		//console.log('chartProps',props)
		return props
	}
}

function getCategoryFilters(indicator) {
	let columns = indicator.columns.items.filter(col => {
		if(col.categoryLabelFlag || col.xAxisFlag) {
			return col;
		}
	})
	return columns
}

//Method called when indicator is initially loaded and line chart is the default chart type
function getLineChartSettings(indicator, type, userInputStatus) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('getLineChartSettings')
		console.log('userInputStatus.year',userInputStatus.year)
		console.log('userInputStatus.geo',userInputStatus.geo)
	}
	AppliedValues.setupAppliedValues(indicator)

	let xAxisDim = indicator.columns.items.find(col => {
		if(col.xAxisFlag
			&& col.columnName == "Year") {
			return col;
		}
	})
	if(xAxisDim == null) {
		throw new Error("Indicator categories are not valid for use on the X Axis")
	}

	//default line chart to show all years
	xAxisDim.appliedValues.forEach(i => {
		i.selected = true
	})

	//default selected category to first valid category, select all values including totals
	let seriesDim = indicator.columns.items.find(col => {
		if(col.categoryLabelFlag && col.columnName !== xAxisDim.columnName) {
			//By rule parent in hierarchies should not be a category
			//TODO: This rule may change for State/Counties
			if(col.childColumnName == null) {
				return col;
			}
		}
	})
	if(seriesDim == null) {
		throw new Error("Indicator categories are not valid for use as a series")
	}

	return new ChartSettings(xAxisDim, seriesDim, type)
}

//Method called when indicator previously loaded and chart type changed to line chart
function updateLineChartSettings(settings, indicator, type, userInputStatus) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('updateLineChartSettings')
		console.log('userInputStatus.year',userInputStatus.year)
		console.log('userInputStatus.geo',userInputStatus.geo)
	}
	settings.type = type

	//In case where xAxis is not set to Year, reset that dim to show All values since it will be replaced by the Year dim
	if(settings.xAxisDim != null) {
		if(settings.xAxisDim.columnName === "Year") {
			//if a range has already been defined for Year, use that range in series
			let selected = settings.xAxisDim.appliedValues.filter(i => i.selected)
			if(selected.length <= 1 || !userInputStatus.year) {
				//If only 1 year selected then default series to all years
				settings.xAxisDim.appliedValues.forEach(i => i.selected = true)
			}
		} else {
			//find Year to set to xAxis
			let dim = indicator.columns.items.find(col => {
				if(col.categoryLabelFlag && col.xAxisFlag
					&& col.columnName == "Year") {
						col.appliedValues.forEach(i => i.selected = true)
					return col;
				}
			})

			if(dim != null) {
				let foundAll = false
				//set old xaxis to default values if present
				const defaultValuesTrimmed = settings.xAxisDim.defaultValues.map(item => 
					typeof item === 'string' ? item.trim() : item
				);
				if(defaultValuesTrimmed.length){
					settings.xAxisDim.appliedValues.forEach(x => {
						if(defaultValuesTrimmed.includes(x.name)){
							x.selected = true
						}else {
							x.selected = false
						}
					})
				}
				//if no default value found, select the first value
				if(!foundAll && settings.xAxisDim.appliedValues.length > 0) {
					settings.xAxisDim.appliedValues[0].selected = true
				}
				//change xaxis to year dim
				settings.xAxisDim = dim
			}
		}
	} else {
		settings.xAxisDim = indicator.columns.items.find(col => {
			if(col.xAxisFlag
				&& col.columnName == "Year") {
					col.appliedValues.forEach(i => i.selected = true)
				return col;
			}
		})
		if(settings.xAxisDim == null) {
			//If no Year dim, use first category as X Axis
			settings.xAxisDim = indicator.columns.items.find(col => {
				if(col.xAxisFlag) {
					col.appliedValues.forEach(i => i.selected = true)
				}
			})
		}
		if(settings.xAxisDim == null) {
			throw new Error("Indicator categories are not valid for use on the X Axis")
		}
	}

	//if series dim not set or if xaxis was changed to series dim, default selected category to first valid category
	//by rule, do not include total value
	if(settings.seriesDim == null || settings.seriesDim.columnName == settings.xAxisDim.columnName) {
		
		let dim = indicator.columns.items.find(col => {
			if(col.categoryLabelFlag && col.columnName !== settings.xAxisDim.columnName) {
				//By rule parent in hierarchies should not be a category
				//TODO: This rule may change for State/Counties
				if(col.childColumnName == null) {
					return col;
				}
			}
		})
		settings.seriesDim = dim
	}

	//If seriesDim is a geography column use defaultValues if user has not input
	if(settings.seriesDim.geoLabelFlag && !userInputStatus.geo) {
		const defaultValuesTrimmed = settings.seriesDim.defaultValues.map(item => 
			typeof item === 'string' ? item.trim() : item
		);
		if(defaultValuesTrimmed.length){
			settings.seriesDim.appliedValues.forEach(x => {
				if(defaultValuesTrimmed.includes(x.name)){
					x.selected = true
				}else {
					x.selected = false
				}
			})
		}
	} 
	//If no values selected, select all as default
	if(!settings.seriesDim.appliedValues.find(x => x.selected)) {
		let allVal = settings.seriesDim.totalLabel
		settings.seriesDim.appliedValues.forEach(x => {
			if(x.name != allVal)
				x.selected = true
		})
	}
	if(settings.seriesDim == null) {
		throw new Error("Indicator categories are not valid for use as a series")
	}
	return settings
}

//Method called when chart is being rebuilt from URL parameters
function rebuildLineChartSettings(indicator, type, objReq) {

	let xAxisDim = indicator.columns.items.find(col => col.columnName == objReq.request.xAxis)
	let reqSeries = objReq.request.categories.find(cat => cat.selected)
	let seriesDim = indicator.columns.items.find(col => col.columnName == reqSeries.categoryName)
	AppliedValues.setupAppliedValues(indicator)
	AppliedValues.applyRequestFilters(indicator, type, objReq.request)
	seriesDim.filters = reqSeries.filters
	return new ChartSettings(xAxisDim, seriesDim, type)
}

function validateRequestProps(obj, indicator) {
	return AppliedValues.validateRequestValues(obj, indicator, ChartTypeEnum.LINE.chartName)
}
export {defineChartProps, refreshLineChart, getLineChartSettings, updateLineChartSettings, rebuildLineChartSettings, validateRequestProps, ChartSettings}
